/**
 * Takes an address and returns a link to google maps
 * @param address - the street address
 * @param city - the city
 * @param state - the state code
 * @param zipCode - the zip code
 * @returns url for the supplied address in Google Maps
 */
export const createGoogleMapsLink = (
  address: string,
  city?: string,
  state?: string,
  zipCode?: string
) => {
  const fullAddress = [address, city, state, zipCode].filter(Boolean).join(', ');
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress)}`;
};
